var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('locationnetworkslocations',{attrs:{"locationnetworkslocations":_vm.LocationNetworksLocations,"locationCount":_vm.locationLength,"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }